import React, { useCallback } from "react";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { debounce } from "lodash";
import { Input } from "@sonder/ui/source/styled/fragments/Input";
import { borders, colors } from "@sonder/ui/source/styled/theme";
import { QUARTER_SECOND } from "core/constants";
import {
  clearSearchTerm,
  updateClientSearchTerm,
  updateServerSearchTerm,
} from "search/actions";
import { useSearchStore } from "search/store";
import { addSearchKeywordToLocalStorage } from "search/utils";

const Wrapper = styled.div`
  align-items: center;
  border-bottom: ${borders.standard};
  box-sizing: border-box;
  display: flex;
  height: 3.429rem;
  padding: 0 1.714rem;
`;

const StyledInput = styled(Input)`
  background-color: transparent;
  border-radius: 0;
  border: none;
  color: ${colors.gray1};
  font-size: 1.143rem;
  width: 100%;
`;

const StyledSearchIcon = styled(SearchIcon)`
  transform: scale(1.143);
`;

const VerticalDivider = styled.div`
  background-color: ${colors.grayE};
  height: 2rem;
  margin: 0 1.714rem;
  width: 1px;
`;

const ClearWrapper = styled.div`
  color: ${colors.gray1};
  cursor: pointer;
`;

const StyledCloseIcon = styled(CloseIcon)`
  && {
    font-size: 1.714rem;
    color: ${colors.gray1};
    &:hover {
      cursor: pointer;
    }
  }
`;

interface SearchBarProps {
  closeModal: () => void;
}

export const SearchBar = ({ closeModal }: SearchBarProps) => {
  const { state, dispatch } = useSearchStore();
  const { clientSearchTerm } = state;

  const debouncedUpdateServerSearchTerm = useCallback(
    debounce((value: string) => {
      addSearchKeywordToLocalStorage(value);
      dispatch(updateServerSearchTerm(value));
    }, QUARTER_SECOND),
    [],
  );

  return (
    <Wrapper>
      <StyledSearchIcon />
      <StyledInput
        value={clientSearchTerm}
        onChange={e => {
          dispatch(updateClientSearchTerm(e.target.value));
          debouncedUpdateServerSearchTerm(e.target.value);
        }}
      />
      {clientSearchTerm.trim() !== "" && (
        <ClearWrapper onClick={() => dispatch(clearSearchTerm())}>
          Clear
        </ClearWrapper>
      )}

      <VerticalDivider />

      <StyledCloseIcon onClick={closeModal} />
    </Wrapper>
  );
};
